import { auth } from '@BUP/configs/Firebase'

export const getIdToken = () => {
  return auth.currentUser.getIdToken()
}
